<template>
  <div style="width: fit-content">
    <div style="display: flex">
      <template v-for="(item, index) in upElementBlocks">
        <div v-if="item.name === 'CustomerDeliveryInfo'" :key="index" class="section form-column" :style="{width: item.width + 'px'}">
          <span class="title">{{ item.title }}</span>
          <div class="form-row" style="display:flex;flex-direction:column;">
            <slot v-for="elementName in item.elementNames" :name="elementName" />
          </div>
        </div>
        <div v-else :key="index" class="section form-column" :style="{width: item.width + 'px'}">
          <el-form :disabled="disabled" label-width="135px" label-position="right">
            <span class="title">{{ item.title }}</span>
            <template v-for="elementName in item.elementNames">
              <slot :name="elementName" />
              <template v-if="elementName === 'jobNo'">
                <slot name="saleProductCode" />
                <slot name="fullOrInside" />
              </template>
            </template>
          </el-form>
        </div>
      </template>
    </div>
    <div v-if="downElementBlock && downElementBlock.name === 'CustomerDeliveryInfo'" class="section" style="width:100%">
      <span class="title">{{ downElementBlock.title }}</span>
      <div class="form-row" style="display:flex;flex-direction:row;margin-top:8px">
        <slot v-for="elementName in downElementBlock.elementNames" :name="elementName" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabLessThanCarloadBaseUICustomLayout',
  props: {
    elementBlocks: { type: Array, required: true },
    disabled: { type: Boolean, default: true }
  },
  computed: {
    upElementBlocks() {
      return this.elementBlocks.filter(p => p.position === 1 && !p.hide)
    },
    downElementBlock() {
      return this.elementBlocks.find(p => p.position === 2 && !p.hide)
    }
  }
}
</script>
